export default __webpack_public_path__ + "static/media/PlaneTop.7a8b412c.svg";